import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization } from "../ApiMethod/ApiMethod";

export const GetProductDetailsBySlug = async (slug) => {
    const url = `${BaseUrl}/GetProductDetailsBySlug?Slug=${slug}`;
    const res = await getApiWithAuthorization(url);

    return res;
};